import { createContext, useContext, useState } from "react";

const RomFooterContext = createContext(null);

export function RomFooterProvider({ children }) {
    // { pct: number, calibrated: bool } when an active ROM result exists, else null.
    const [footer, setFooter] = useState(null);
    return (
        <RomFooterContext.Provider value={{ footer, setFooter }}>
            {children}
        </RomFooterContext.Provider>
    );
}

export function useRomFooter() {
    return useContext(RomFooterContext) || { footer: null, setFooter: () => {} };
}
